module.exports = "/_next/static/videos/lacrosse-3-f41951fbd067e5a08b8d5c7ebc40f388.webm";